import { render } from "./ButtonAI.vue?vue&type=template&id=174e4d36&scoped=true"
import script from "./ButtonAI.vue?vue&type=script&lang=js"
export * from "./ButtonAI.vue?vue&type=script&lang=js"

import "./ButtonAI.vue?vue&type=style&index=0&id=174e4d36&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-174e4d36"]])

export default __exports__